/* eslint-disable */
import moment from 'moment'

const isThirdNonWeekendDayFromToday = (day) => {
  const weekdayOfToday = moment().weekday()
  let dayDiff = 0
  switch (weekdayOfToday) {
    case 4:
      dayDiff = 4
      break
    case 5:
      dayDiff = 4
      break
    default:
      dayDiff = 3
  }
  return moment(day).isSame(
    moment()
      .add(dayDiff, `days`)
      .startOf(`day`),
    `day`,
  )
}

export default isThirdNonWeekendDayFromToday
